import React, { Component } from 'react'
import Header from './header'
import { Container, Dimmer, Message, Loader } from 'semantic-ui-react'
import {connect} from 'react-redux'
import {getBasicData} from '../../actions/account.action'
import './app.css'

const AppShell = class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: true,
      isValidated: false
    }
  }
  loadData () {
    const _this = this
    this.props.getBasicData(function (err, results) {
      if (err) {
        _this.setState({
          isLoading: false,
          isValidated: false
        })
      } else {
        _this.setState({
          isLoading: false,
          isValidated: true
        })
      }
    })
  }
  loadAdd () {
    var w = window; var ic = w.Intercom; if (typeof ic === 'function') { ic('reattach_activator'); ic('update', window.intercomSettings) } else { var d = document; var i = function () { i.c(arguments) }; i.q = []; i.c = function (args) { i.q.push(args) }; w.Intercom = i; function l () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/pdxk5ajo'; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x) } if (w.attachEvent) { w.attachEvent('onload', l) } else { w.addEventListener('load', l, false) } }
  }
  componentWillMount () {
    this.loadData()
  }
  componentDidMount () {
    window.intercomSettings = {
      app_id: 'pdxk5ajo'
    }
    const token = window.localStorage.getItem('token')
    if (token) {
      this.loadAdd()
    }
  }
  render () {
    const {children} = this.props
    // const {hasError, error} = this.state
    // let errorNode

    // @TODO: show global error from viewState
    // if (hasError) {
    //   errorNode = <p>{error.message}</p>
    // }
    if (this.state.isLoading) {
      return (
        <div>
          <Dimmer active inverted>
            <Loader />
          </Dimmer>
        </div>
      )
    } else if (!this.state.isValidated) {
      return (
        <div>
          <Header />
          <Container className='app--content'>
            <h1>Renew Risqover licenses</h1>
            <Message negative>
              <Message.Header>Renew Risqover licenses</Message.Header>
              <p>Your account is currently inactive. To renew your licenses, please contact us.
              </p>
            </Message>
          </Container>
        </div>
      )
    }
    return (
      <div>
        <Header />
        <Container className='app--content'>
          {children}
        </Container>
      </div>
    )
  }
}
function mapStateToProps (state) {
  return {account: state.account.user}
}
// export default AppShell
export default connect(mapStateToProps, {getBasicData})(AppShell)



// WEBPACK FOOTER //
// ./src/containers/appshell/index.js